class StringUtils {
  public static replaceCharacterGloballyByKey(value: string, key: string, replaceValue: string) {
    const regex = new RegExp(key, 'g')

    return value.replace(regex, replaceValue)
  }
}

export default StringUtils
